/**
 * Capacitor Auth Deep Link Handler
 *
 * Handles the OAuth callback when the system browser redirects
 * back to the app via the custom URL scheme.
 */
import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'
import { Browser } from '@capacitor/browser'

/**
 * Set up a listener for deep link callbacks from OAuth.
 * When the system browser completes the OAuth flow, it redirects
 * to the app's URL scheme. This handler catches that redirect,
 * closes the browser, and calls the provided callback with the URL.
 */
export function setupDeepLinkHandler(onUrl: (url: string) => void): void {
  if (!Capacitor.isNativePlatform()) return

  App.addListener('appUrlOpen', async ({ url }) => {
    await Browser.close()
    onUrl(url)
  })
}
